import dynamic from "next/dynamic";

import AppLayout from "../../components/AppLayout";
import Reviews from "../../components/Reviews";
import ProductServiceSection from "../../components/ProductServiceSection";
import StepsSection from "../Home/StepsSection";
import TitleBannerSection from "./TitleBannerSection";
import Banner from "./Banner";
import ClosetsExplanation from "./ClosetsExplanation";
import CategorySection from "./CategorySection";
import { Container, Divider } from "./styled";
import { reviewsData, productsAndServicesData } from "../../data/_closets";

const Closets = () => {
  return (
    <div>
      <AppLayout>
        <Container>
          <TitleBannerSection />
          <Banner />
          <ClosetsExplanation />
          <StepsSection />
          <CategorySection />
          <Reviews
            title={reviewsData.title}
            coverImg={reviewsData.coverImg}
            reviewsData={reviewsData.reviews}
          />
          <Divider />
          <ProductServiceSection
            productsServicesData={productsAndServicesData}
          />
        </Container>
      </AppLayout>
    </div>
  );
};

export default Closets;
